module.exports = __webpack_public_path__ + "static/media/airstrip-one-logo.32703e46.png";